module.exports = __webpack_public_path__ + "img/paySixPicM.c9fce068.png";